import React, { ReactElement, useMemo } from 'react'
import RawPicker from '@emoji-mart/react'
import { FrequentlyUsed } from 'emoji-mart'
import { emojiData } from '@manychat/generate-emoji'

import { defaultCategoryIds, hasEmojiSupport } from 'utils/emoji'

import InstagramChannelIconSvg from './InstagramChannelIcon.svg'
import { SelectedEmoji, PickerProps } from './types'
import { getRecentEmoji } from './utils'

import './EmojiList.module.css'

const INSTAGRAM_CATEGORY_ID = 'instagram'
const Picker = RawPicker as (props: PickerProps) => ReactElement

/**
 * Pass our own emojis from the legacy storage to the frequently used emojis
 * @see https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart/src/helpers/frequently-used.ts#L4
 */
;(() => {
  FrequentlyUsed.DEFAULTS.length = 0
  FrequentlyUsed.DEFAULTS.push(...getRecentEmoji())
})()

interface EmojiListProps {
  onSelect: (emoji: SelectedEmoji) => void
  includeInstagramCategory?: boolean
}

export function EmojiList({ onSelect = () => {}, includeInstagramCategory }: EmojiListProps) {
  const categories = useMemo(() => {
    const categories = [...defaultCategoryIds]

    if (includeInstagramCategory) {
      categories.unshift('instagram')
    }

    return ['frequent', ...categories]
  }, [includeInstagramCategory])

  const custom = useMemo(() => {
    const emojis = Object.values(emojiData.emojis).filter((emoji) => {
      return emoji.skins.some((skin) => ['😂', '😮', '😍', '😢', '👏', '🔥'].includes(skin.native))
    })

    return [
      {
        id: INSTAGRAM_CATEGORY_ID,
        name: 'Quick Reactions in Instagram',
        emojis,
      },
    ]
  }, [])

  const categoryIcons = useMemo(() => {
    return {
      [INSTAGRAM_CATEGORY_ID]: {
        src: InstagramChannelIconSvg,
      },
    }
  }, [])

  return (
    <Picker
      data={emojiData}
      skinTonePosition="none"
      onEmojiSelect={onSelect}
      categories={categories}
      custom={custom}
      categoryIcons={categoryIcons}
      set={hasEmojiSupport() ? 'native' : 'apple'}
    />
  )
}
